"use strict";
/* eslint-disable @typescript-eslint/no-duplicate-type-constituents */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleSortFileds = exports.StringFields = exports.DateTimeFields = exports.NumericFields = exports.BooleanOp = exports.StringOp = exports.DateTimeOp = exports.NumericOp = void 0;
exports.NumericOp = ['=', '<>', '>', '>=', '<', '<='];
exports.DateTimeOp = exports.NumericOp;
exports.StringOp = ['=', '<>', '>', '>=', '<', '<=', '~', '!~'];
exports.BooleanOp = ['is null', 'is not null'];
exports.NumericFields = ['volume', 'documentId', 'documentPartId'];
exports.DateTimeFields = ['creationTime'];
exports.StringFields = ['sequenceUid', 'source'];
exports.SimpleSortFileds = ['volume', 'sequenceUid', 'documentId', 'documentPartId', 'creationTime'];
//# sourceMappingURL=century-types-filter.js.map